import { render, staticRenderFns } from "./MemberList.vue?vue&type=template&id=356de4aa&scoped=true"
import script from "./MemberList.vue?vue&type=script&lang=js"
export * from "./MemberList.vue?vue&type=script&lang=js"
import style0 from "./MemberList.vue?vue&type=style&index=0&id=356de4aa&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356de4aa",
  null
  
)

export default component.exports